import React, { useState } from 'react';

const FilterFronteiraComponent = ({ municipios, onChange, onSelectMunicipio, selectedStates }) => {
    const [selectedUF, setSelectedUF] = useState('');
    const [selectedMunicipio, setSelectedMunicipio] = useState('');

    // Verificando se selectedStates é uma matriz válida
    const statesToDisplay = Array.isArray(selectedStates) ? selectedStates : [];

    // Filtrando os municípios com base no estado selecionado
    const filteredMunicipios = municipios.filter(municipio => municipio.properties.uf === selectedUF);

    const handleSelectChange = (e) => {
        const selectedUF = e.target.value;
        setSelectedUF(selectedUF);
        setSelectedMunicipio('');
        onChange(selectedUF);
    };

    const handleMunicipioChange = (e) => {
        const selectedMunicipio = e.target.value;
        setSelectedMunicipio(selectedMunicipio);
        onSelectMunicipio(selectedMunicipio); // Adicionado
    };

    return (
        <div style={{ marginBottom: '20px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <select
                style={{
                    width: '100%', // Definindo a largura para 100%
                    maxWidth: '300px', // Definindo a largura máxima para 300px
                    padding: '8px',
                    border: '1px solid #ccc',
                    borderRadius: '5px',
                }}
                value={selectedUF}
                onChange={handleSelectChange}
            >
                <option value="">Selecione uma UF</option>
                {statesToDisplay.map((uf, index) => (
                    <option key={index} value={uf}>{uf}</option>
                ))}
            </select>

            {selectedUF && (
                <div style={{ marginTop: '10px', width: '100%', maxWidth: '300px' }}> {/* Definindo a largura para 100% */}
                    <label htmlFor="municipios" style={{ display: 'block', marginBottom: '5px' }}></label>
                    <select
                        id="municipios"
                        style={{
                            width: '100%', // Definindo a largura para 100%
                            padding: '8px',
                            border: '1px solid #ccc',
                            borderRadius: '5px',
                        }}
                        value={selectedMunicipio}
                        onChange={handleMunicipioChange}
                    >
                        <option value="">Selecione um município</option>
                        {filteredMunicipios.map((municipio, index) => (
                            <option key={index} value={municipio.properties.nome}>{municipio.properties.nome}</option>
                        ))}
                    </select>
                </div>
            )}
        </div>
    );
};

export default FilterFronteiraComponent;
